const SESSION_KEY = 'session';

/**
 * Get session from localStorage
 * @returns {Object|null} Session object or null if not found
 */
export const getSession = () => {
  try {
    const sessionStr = localStorage.getItem(SESSION_KEY);
    if (!sessionStr) return null;
    return JSON.parse(sessionStr);
  } catch (error) {
    console.error('Error reading session from localStorage:', error);
    return null;
  }
};

/**
 * Save session to localStorage
 * @param {Object} sessionData - Session data to save
 */
export const saveSession = (sessionData) => {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
  } catch (error) {
    console.error('Error saving session to localStorage:', error);
  }
};

/**
 * Clear session from localStorage
 */
export const clearSession = () => {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch (error) {
    console.error('Error clearing session from localStorage:', error);
  }
};

/**
 * Update session with new token data and recalculate expiry
 * @param {Object} newTokenData - New token data from refresh response
 * @param {Object} currentSession - Current session object
 * @returns {Object} Updated session object
 */
export const updateSession = (newTokenData, currentSession) => {
  const loginTime = currentSession.loginTime || Date.now();
  const expiresIn = newTokenData.expires_in || 3600; // default to 1 hour if not provided
  const expire = Date.now() + expiresIn * 1000;

  const updatedSession = {
    ...currentSession,
    access_token: newTokenData.access_token,
    refresh_token: newTokenData.refresh_token || currentSession.refresh_token,
    token_type:
      newTokenData.token_type || currentSession.token_type || 'Bearer',
    expire,
    loginTime,
  };

  saveSession(updatedSession);
  return updatedSession;
};
